import React from 'react'
import { useSelector } from 'react-redux'
import Icon from 'icons/Icon'
import Slider from 'components/Slider/Slider'
import { CONTROL_POSITION, SLIDE_TYPES } from 'constants/slider'
import useBreakpoint from 'utils/useBreakpoint'
import { BREAK_POINTS } from 'constants/uiConfig'
import './styles/index.scss'

const BenefitsStrip = () => {
  const languageData = useSelector(state => state.language?.languageData)
  const breakpoint = useBreakpoint()

  const items = [
    {
      key: 'secured',
      icon: 'shield',
      title: languageData?.benefitsSecuredTransactions || 'Secured Transactions',
      desc: languageData?.benefitsSecuredTransactionsDesc || 'Every transaction is encrypted, verified, and protected.'
    },
    {
      key: 'tournaments',
      icon: 'swords',
      title: languageData?.benefitsLiveTournaments || 'Live Tournaments',
      desc: languageData?.benefitsLiveTournamentsDesc || 'Experience the thrill of live tournaments anytime, anywhere.'
    },
    {
      key: 'support',
      icon: 'support',
      title: languageData?.benefits247Support || '24/7 Support',
      desc: languageData?.benefits247SupportDesc || 'Round-the-clock support to keep your game running smoothly.'
    }
  ]

  const renderSlide = ({ game: item }) => (
    <div className='benefits-strip__item'>
      <div className='benefits-strip__icon' aria-hidden='true'>
        <Icon name={item.icon} />
      </div>
      <div className='benefits-strip__content'>
        <div className='benefits-strip__title'>{item.title}</div>
        <div className='benefits-strip__desc'>{item.desc}</div>
      </div>
    </div>
  )

  // Enable drag on mobile view (sm and xs breakpoints - 767px and below)
  const isMobileView = breakpoint === BREAK_POINTS.sm || breakpoint === BREAK_POINTS.xs
  const dragAllowed = isMobileView

  return (
    <>
      <div className='benefits-strip benefits-strip--carousel'>
        <Slider
          slides={items}
          sliderCard={renderSlide}
          type={SLIDE_TYPES.BENEFITS_STRIP}
          showNavigation
          controlPosition={CONTROL_POSITION.BOTTOM}
          showHeader={false}
          loop={false}
          dragAllowed={dragAllowed}
        />
      </div>
    </>
  )
}

export default BenefitsStrip
